"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintableUTurnIcon = PrintableUTurnIcon;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PrintableUTurnIcon(_ref) {
  let {
    color,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_renderer.Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement(_renderer.Path, {
    d: "M12 0c-6.616 0-12 5.385-12 12.002s5.383 11.998 12 11.998 12-5.382 12-11.998-5.384-12.002-12-12.002zM12 22.92c-1.712 0-3.326-0.407-4.77-1.111v-12.476c0-2.053 1.671-3.724 3.725-3.724s3.725 1.671 3.725 3.724v7.215l-3.327-3.329c-0.219-0.219-0.576-0.217-0.795 0-0.219 0.219-0.219 0.578 0 0.797l4.287 4.285c0.002 0.002 0.003 0 0.005 0.002 0.101 0.099 0.24 0.162 0.393 0.162v0 0c0 0 0 0 0 0 0.154 0 0.294-0.063 0.396-0.163v0l4.287-4.285c0.219-0.219 0.219-0.578 0-0.797-0.219-0.217-0.576-0.219-0.795 0l-3.326 3.326v-7.212c0-2.674-2.175-4.849-4.85-4.849s-4.85 2.173-4.85 4.849v11.846c-3.018-1.946-5.025-5.328-5.025-9.177 0-6.022 4.899-10.92 10.92-10.92s10.92 4.899 10.92 10.92c0 6.021-4.898 10.918-10.92 10.918z",
    fill: color
  }));
}